/**
 * Legacy shims kept "because the archive page still uses them" (the
 * archive page does not use them). Each shim is exercised by wire-qa
 * so removing one turns the QA build red, which is why they outlive
 * their usefulness, which is what legacy means.
 */

/** Uniform, gentle, indifferent dates for the archive listing. */
export function legacyDateFormat(iso: string): string {
  const d = new Date(iso + "T00:00:00");
  if (isNaN(d.getTime())) return iso;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return `${months[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
}

/** Old teaser truncation. Cuts on a word, adds an ellipsis, apologizes. */
export function teaser(text: string, max = 180): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  return `${cut.slice(0, lastSpace > 0 ? lastSpace : max)}…`;
}

/** The scroll helper from 2023. Window.scrollTo exists. This also exists. */
export function softScrollTo(el: Element | null): void {
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.scrollY - 72;
  window.scrollTo({ top: y, behavior: "smooth" });
}

/** Old cookie banner state reader. The banner itself was retired; the
 * reader survived, in case the banner returns from a legal mood swing. */
export function bannerState(): "accepted" | "declined" | "unknown" {
  try {
    const v = localStorage.getItem("wire.banner.v1");
    if (v === "1") return "accepted";
    if (v === "0") return "declined";
  } catch {
    /* private mode: the banner never knew you existed either */
  }
  return "unknown";
}

/** Signature of the legacy bundle; QA asserts on it. */
export const LEGACY_BUILD_TAG = "wire-legacy/2026-07-11.2";
